const minPasswordLength = 6

export default {
  data () {
    return {
      rules: {
        required: value => !!value || 'Required.',
        emailAddress: value =>
          !value || /.+@.+\..+/.test(value) || 'Invalid email address.',
        phoneNumberE164: value => /^\+?[1-9]\d{1,14}$/.test(value) || 'Invalid phone number. Use numbers only.',
        compare: (otherField, errMessage) => {
          return value => {
            return (
              (!value && !otherField) ||
              (!!value && value === otherField) ||
              errMessage
            )
          }
        }
      },
      passwordRules: [
        value =>
          !value ||
          /^(?=.*\d).*$/.test(value) ||
          'Requires at least one digit.',
        value =>
          !value ||
          /^(?=.*[A-Z]).*$/.test(value) ||
          'Requires at least one uppercase letter.',
        value =>
          !value ||
          /^(?=.*[a-z]).*$/.test(value) ||
          'Requires at least one lowercase letter.',
        value =>
          !value ||
          (value != null && value.length > minPasswordLength) ||
          `Must be at least ${minPasswordLength} characters in length.`,
        value =>
          !value ||
          /^(?=.*[\W_]).*$/.test(value) ||
          'Requires at least one non-alphanumeric character.'
      ]
    }
  }
}
